import React from 'react';

import * as analytics from 'analytics/Analytics';
import * as benchlingUtil from 'BenchlingUtil';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';
import Modal, {ModalButton} from 'ui-library/modals/Modal';
import {getPNGFileForSVG} from 'util/SVGUtil';

interface ExportPNGModalProps {
  title: string;
  downloadName: string;
  onRequestClose: () => void;
  renderSVG: () => Promise<SVGSVGElement>;
}

interface ExportPNGModalState {
  pngURL: null | string;
  failed: boolean;
}

class ExportPNGModal extends React.Component<ExportPNGModalProps, ExportPNGModalState> {
  override state: ExportPNGModalState = {
    pngURL: null,
    failed: false,
  };

  override async componentDidMount(): Promise<void> {
    const svg = await this.props.renderSVG();
    try {
      const pngURL = await getPNGFileForSVG(svg, this.props.downloadName);
      this.setState({pngURL});
      // eslint-disable-next-line benchlint/always-throw-from-catch
    } catch (e) {
      this.setState({failed: true});
    }
    analytics.track('protein_alignment', 'created_png');
  }

  _renderPreview = (): JSX.Element => {
    if (this.state.failed) {
      return (
        <div>
          <p>
            {'Generating the PNG failed. Please try again or '}
            <a
              onClick={() => {
                benchlingUtil.contactBenchlingViaEmail();
              }}
            >
              contact us
            </a>
            .
          </p>
        </div>
      );
    } else if (this.state.pngURL) {
      return (
        <div className="exportPNGModal-preview">
          <img src={this.state.pngURL} />
        </div>
      );
    } else {
      return (
        <div className="text-center u-spacing-top u-spacing-bottom">
          <HorizontalThrobber />
        </div>
      );
    }
  };

  _handleDownloadPNG = (): void => {
    window.open(this.state.pngURL!);
    this.props.onRequestClose();
    analytics.track('protein_alignment', 'downloaded_png');
  };

  _getPrimaryButton = (): Array<ModalButton> => {
    if (this.state.failed) {
      return [];
    } else {
      return [
        {
          disabled: !this.state.pngURL,
          key: 'download',
          submit: true,
          text: this.state.pngURL ? 'Download PNG' : 'Generating PNG...',
        },
      ];
    }
  };

  override render(): JSX.Element {
    return (
      <Modal
        title={this.props.title}
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this.state.failed ? null : this._handleDownloadPNG}
        buttons={this._getPrimaryButton()}
      >
        {this._renderPreview()}
      </Modal>
    );
  }
}

export default ExportPNGModal;
